// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const useBulletListStyle = makeStyles((theme: Theme) =>
  createStyles({
    bulletList: {
      listStyleType: "square",
      paddingLeft: "1em",
      listStylePosition: "outside",
      "& li": {
        margin: "1rem 0",
      },
    },
  })
);

export default useBulletListStyle;
